<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.aiExtraction}}</h3>
    <h5 class="modal-subtitle">
		<span [innerHTML]="product.title | safeHtml"></span>
	</h5>
</div>
<div class="modal-body">
	<div style="max-height:650px;overflow-y:auto;overflow-x:hidden;">
		<div class="col-xs-12">
            <div class="col-xs-12">
            	<div class="col-xs-6">
                <label class="radio">
					<input type="radio" [(ngModel)]="provider" value="open_ai">{{providers['open_ai'].name}}
					<span *ngIf="providers['open_ai'].available" class="text-success">{{LOCALIZATION.available}} <i class="fa fa-check" style="font-size:1.0em"></i></span>
					<span *ngIf="!providers['open_ai'].available" class="text-danger">{{LOCALIZATION.unavailable}} <i class="fa fa-times" style="font-size:1.0em"></i></span>
				</label>
				</div>
				<div class="col-xs-6">
					<div *ngIf="provider === 'open_ai'">
						<label for="model">{{LOCALIZATION.model}}</label>
						<select id="model" name="model" class="form-control" [(ngModel)]="providers['open_ai'].model">
						  <option value="" disabled selected>{{LOCALIZATION.aiModelSelect}}</option>
						  <option *ngFor="let model of providers['open_ai'].models" [ngValue]="model.id">{{ model.id }}</option>
						</select>
					</div>
				</div>
				<div class="col-xs-12">
                <label class="radio">
					<input type="radio" [(ngModel)]="provider" value="local_llm">{{providers['local_llm'].name}}
					<span *ngIf="providers['local_llm'].available" class="text-success">{{LOCALIZATION.available}} <i class="fa fa-check" style="font-size:1.0em"></i></span>
					<span *ngIf="!providers['local_llm'].available" class="text-danger">{{LOCALIZATION.unavailable}} <i class="fa fa-times" style="font-size:1.0em"></i></span>	
				</label>
				</div>
            </div>			
			<div class="col-xs-12" style="margin-top:12px;">
				<hr>
				<h4>How can I help you?</h4>
				<div *ngIf="provider === 'open_ai'" class="helpContent">
					<div class="help-block">
						Enter a list of data elements to extract from the document. Here are some examples:
					</div>
					<div style="font-family: monospace; padding: 8px 0;">
					    geographic places, people, urls, dates
					</div>
					<div style="font-family: monospace;">
						intent, summary, topics, keywords
					</div>	
				</div>
			</div>
		</div>
		<div class="col-xs-12">
			<textarea class="form-control" maxlength="400" rows="4" [(ngModel)]="userinput"></textarea>
			<span class="help-block">{{userinput.length}}/400</span>				
		</div>
		<hr>
		<div class="col-xs-12 well" *ngIf="result.answer || Object.keys(result.extractions).length > 0">				
			<div [hidden]="!submitting"><i class="fas fa-spinner fa-spin fa-fw"></i></div>
			
			<!-- local_llm -->
			<div style="padding: 0 0 16px 0;">{{result.answer}}</div>
			<div *ngFor='let doc of result.source_documents' class="list-group-item hoverme">
				<div><span style="font-weight: bold;">Source: </span><span class="pointMe link" (click)="searchDoc(doc.source)">{{doc.filename}}</span></div>
				<p style="font-family: monospace; padding: 8px 0; word-wrap: break-word;">{{doc.content}}</p>
			</div>			
			
			<!-- open_ai -->
			<div *ngFor='let resultvalue of result.extractions' class="list-group-item hoverme" style="word-wrap: break-word;">
				<h4 class="list-group-item-heading capitalize">{{resultvalue.key}}</h4>
				<p>{{resultvalue.value}}</p>
			</div>            			
			
			<div *ngIf="result.model" class="well-sm right text-muted">{{LOCALIZATION.poweredByPrefix}}: <span class="text-info">{{result.model}}</span> -- {{result.createdStr}}</div>				
		</div>
	</div>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
	<button class="btn btn-primary" type="button" (click)="submitRequest()" [disabled]="submitting">
		<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!submitting"></i>
		{{LOCALIZATION.submit}}
	</button>
</div>
